module.exports = __webpack_public_path__ + "img/20180815_150347_080.8b6f8e61.jpg";